/**
 * Geometria da página. SPEC §7.4.
 *
 * A página tem tamanho lógico fixo; o canvas escala para o dispositivo.
 * Cabeçalho = linha 0. As linhas 1..ROWS são as faixas da pauta.
 */
export const PAGE_W = 1000;
export const PAGE_H = 1414;
export const HEADER_H = 132; // altura do cabeçalho (linha 0)
export const LINE_H = 46; // altura de cada faixa da pauta
export const ROWS = 27; // (1414 - 132) / 46 = 27,8 -> 27 linhas inteiras
export const MARGIN_X = 92; // margem vertical vermelha

/** Linha da pauta em que um y cai. 0 = cabeçalho. */
export function rowOfY(y: number): number {
  if (y < HEADER_H) return 0;
  return Math.min(ROWS, Math.floor((y - HEADER_H) / LINE_H) + 1);
}

/** y do meio de uma linha (para rolar até ela / desenhar destaque). */
export function rowMidY(row: number): number {
  if (row <= 0) return HEADER_H / 2;
  return HEADER_H + (row - 0.5) * LINE_H;
}

/** Topo e base de uma linha, para destacar a faixa inteira. */
export function rowBandY(row: number): [number, number] {
  if (row <= 0) return [0, HEADER_H];
  const top = HEADER_H + (row - 1) * LINE_H;
  return [top, top + LINE_H];
}

export type BBox = [number, number, number, number]; // minX, minY, maxX, maxY

/**
 * A linha de um traço sai do CENTRO VERTICAL do bbox, não do topo:
 * colchetes, setas e círculos que cruzam várias linhas caem na linha do meio
 * em vez de na primeira que tocam (SPEC §7.4).
 */
export function rowOfBBox(b: BBox): number {
  return rowOfY((b[1] + b[3]) / 2);
}

export function bboxOfPoints(points: Float32Array | number[], stride = 4): BBox {
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  for (let i = 0; i < points.length; i += stride) {
    const x = points[i] as number;
    const y = points[i + 1] as number;
    if (x < minX) minX = x;
    if (x > maxX) maxX = x;
    if (y < minY) minY = y;
    if (y > maxY) maxY = y;
  }
  if (minX === Infinity) return [0, 0, 0, 0];
  return [minX, minY, maxX, maxY];
}

export function bboxIntersects(a: BBox, b: BBox, pad = 0): boolean {
  return !(a[2] + pad < b[0] || a[0] - pad > b[2] || a[3] + pad < b[1] || a[1] - pad > b[3]);
}
